import firebase from "firebase/app";

import { Card, Dropdown, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import updateDistributionChannel from "astrid-firestore/src/api/distribution/updateDistributionChannel";

import Flex from "../../../../../components/Flex/Flex";
import { useProfile } from "../../../../authentication/state/profile";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";
import ImageAvatarNew from "../../../../ui/components/ImageAvatarNew/ImageAvatarNew";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";
import useSingleFileUpload from "../../../../ui/hooks/useSingleFileUpload";

export default function SuperAdminChannelInfo({ channel }) {
	const { t } = useTranslation();
	const user = useProfile();

	const [{ input, loading, error: errorImageUpload, uploadFile }] = useSingleFileUpload({
		bucketName: "earselect-public",
		accept: "image/*",
		getDestination: () => `channelIcons/${channel.id}`,
		onSuccess: (icon) => {
			return updateDistributionChannel(firebase, { ref: channel.ref, icon, updatedBy: user });
		},
	});

	return (
		<Card fluid>
			<Card.Content>
				<Flex>
					<Flex justifyContent="flex-start" gap={10}>
						<ImageAvatarNew abbr={channel.abbreviation} src={channel.icon?.url} />

						<Header style={{ margin: 0 }}>{channel.name}</Header>
					</Flex>

					<DropdownMenu loading={loading}>
						{() => (
							<>
								<Dropdown.Item
									text={t("uploadChannelIcon", "Upload new channel icon")}
									onClick={uploadFile}
								/>
							</>
						)}
					</DropdownMenu>
				</Flex>

				{errorImageUpload && <ErrorMessage error={errorImageUpload} />}
			</Card.Content>

			{input}
		</Card>
	);
}
